import PropTypes from 'prop-types';
import DocInvTable from './DocInvTable';

const DocBody = ({bodySpec, widgetData}) => {
  return (
    <>
      <DocInvTable
        bodySpec={bodySpec.productbreakdown}
        dataSet={widgetData.packageList}
      />

      <DocInvTable
        bodySpec={bodySpec.costbreakdown}
        dataSet={widgetData.costList}
      />
    </>
  );
};

DocBody.propTypes = {
  bodySpec: PropTypes.object.isRequired,
  widgetData: PropTypes.object.isRequired,
};

export default DocBody;
